import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=1deb9b6a&scoped=true&"
import script from "./ClickToEdit.vue?vue&type=script&lang=js&"
export * from "./ClickToEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=1deb9b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb9b6a",
  null
  
)

export default component.exports